import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetAllEmbalagemResponse } from '../../responses/produto/get-all-embalagem.response';
import { GetEmbalagemResponse } from '../../responses/produto/get-embalagem.response';
import { EmbalagemRequest } from '../../requests/produto/embalagem.request';
import { ReturnStruct } from '../../structs/return.struct';
import { GetListaPrecoResponse } from '../../responses/produto/get-lista-preco.response';
import { ListaPrecoBulkDeleteRequest } from '../../requests/produto/lista-preco-bulk-delete.request';
import { GetListaPrecoDetailResponse } from '../../responses/produto/get-lista-preco-detail.response';
import { ListaPrecoRequest } from '../../requests/produto/lista-preco.request';
import { GetPrecosProdutosAutomaticosRequest } from '../../requests/produto/get-precos-produtos-automaticos.request';
import { GetLookupsListaPrecoResponse } from '../../responses/produto/get-lookups-lista-preco.response';

@Injectable({
    providedIn: 'root',
})
export class ListaPrecoService extends CommonService {
    constructor(
        private httpClient: HttpClient
    ) {
        super();
    }

    private readonly apiUrl = `${environment.urlApiProduto}listaPreco`;

    public getAll(nome: string = '', pagina: number = 1, tamanhoPagina: number = 20): Observable<GetListaPrecoResponse> {
        let params = new HttpParams()
            .set('pagina', pagina.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());

        if (nome) {
            params = params.set('nome', nome);
        }

        return this.httpClient
            .get<GetListaPrecoResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    public excluir(request: ListaPrecoBulkDeleteRequest): Observable<ReturnStruct> {
        return this.httpClient
            .post<ReturnStruct>(`${this.apiUrl}/bulk-delete`, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public get(idListaPreco: number): Observable<GetListaPrecoDetailResponse> {
        return this.httpClient
            .get<GetListaPrecoDetailResponse>(`${this.apiUrl}/${idListaPreco}`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public getLookups(): Observable<GetLookupsListaPrecoResponse> {
        return this.httpClient
            .get<GetLookupsListaPrecoResponse>(`${this.apiUrl}/lookups`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public post(listaPrecoRequest: ListaPrecoRequest): Observable<ReturnStruct> {
        return this.httpClient
            .post<ReturnStruct>(`${this.apiUrl}`, listaPrecoRequest, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public put(idListaPreco: number, listaPrecoRequest: ListaPrecoRequest): Observable<ReturnStruct> {
        return this.httpClient
            .put<ReturnStruct>(`${this.apiUrl}/${idListaPreco}`, listaPrecoRequest, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public CalcularPrecosProdutosAutomaticos(getPrecosProdutosAutomaticosRequest: GetPrecosProdutosAutomaticosRequest): Observable<GetListaPrecoDetailResponse> {
        return this.httpClient
            .post<GetListaPrecoDetailResponse>(`${this.apiUrl}/CalcularPrecosProdutosAutomaticos`, getPrecosProdutosAutomaticosRequest, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
